import React from 'react';
import { DiaryAttachments } from '@/components/DiaryAttachments';
import { DiaryTextList } from '@/components/DiaryTextList';
import { LessonScheduledTest } from '@/components/LessonScheduledTest';
import type { AttachmentsDisplay } from '@/types/components';
import type { DiaryTopic, TextWithAttachments } from '@/types/diary';

interface Props {
  topics: DiaryTopic[];
  scheduledTest?: TextWithAttachments;
  attachmentsDisplay?: AttachmentsDisplay;
  isFullText?: boolean;
  className?: string;
}

export const DiaryTopics: React.FC<Props> = ({
  topics,
  scheduledTest,
  attachmentsDisplay,
  isFullText,
  className,
}) => {
  const topicTexts = topics.map(({ text }) => text);
  const topicAttachments = [
    ...topics.flatMap(({ attachments }) => attachments),
    ...(scheduledTest?.attachments ?? []),
  ];

  return (
    <div className={`flex min-w-0 flex-col gap-3 ${className ?? ''}`}>
      {topicTexts.length > 0 && (
        <DiaryTextList texts={topicTexts} isFullText={isFullText} />
      )}

      {scheduledTest && <LessonScheduledTest test={scheduledTest} />}

      <DiaryAttachments
        attachments={topicAttachments}
        display={attachmentsDisplay}
      />
    </div>
  );
};
